/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { ENVIRONMENT, type Environment } from './environment';
import { FF_DEV_QUICK_ENTRY } from './feature-flag';

const BRIDGE_ENVIRONMENTS: readonly Environment[] = ['local', 'testing', 'staging'];

/**
 * Determines whether forms should publish their imperative DEV bridge on
 * `window` for the Dev Cockpit Form Filler.
 *
 * `import.meta.env.DEV` alone is false in every `vite build` output, so deployed
 * environments used to show the Form Filler tool while no form ever exposed a
 * bridge. This mirrors the tool's own gates (environment plus
 * `FF_DEV_QUICK_ENTRY`), keeping the bridge out of production.
 *
 * @returns True when the bridge may be exposed in the current environment.
 */
export function isDevFormBridgeEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  return BRIDGE_ENVIRONMENTS.includes(ENVIRONMENT) && FF_DEV_QUICK_ENTRY;
}
